import {inject, Injectable} from '@angular/core';
import {BrowserService} from '@core/service/browser.service';
import {environment} from '@environments/environment';
import {User} from '@domain/user/user';

declare global {
  interface Window {
    umami?: {
      identify: (data: string | object, sessionData?: object) => void;
      track: (eventName: string | object, eventData?: object) => void;
    };
  }
}

@Injectable({
  providedIn: 'root'
})
export class UmamiService {

  private readonly browserService = inject(BrowserService);

  private _trackedUser: User | null = null;

  public init(): void {
    if (this.browserService.isBrowser) {
      const umamiConfig = environment.umami;
      const script = document.createElement('script');
      script.async = true;
      script.src = `${umamiConfig.url}/script.js`;
      script.setAttribute('data-website-id', umamiConfig.websiteId);
      document.head.appendChild(script);
    }
  }

  identifyUser(user: User | null): void {
    if (this.browserService.isBrowser) {
      if (user?.id && user.id !== this._trackedUser?.id) {
        window.umami?.identify({email: user.email, lang: user.lang});
        window.umami?.identify(user.id, {email: user.email, lang: user.lang});
        this._trackedUser = user;
      }
    }
  }

  clearUser(): void {
    if (this.browserService.isBrowser && this._trackedUser) {
      window.umami?.identify({});
      this._trackedUser = null;
    }
  }
}
